import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { CustomAction } from '@nimmsta/ng-commons-lib/data-table';
import { User, UserStatus } from '@nimmsta/ng-commons-lib/models';
import { Observable, of } from 'rxjs';

_('user.unlock');
_('user.lock');

export class LockUnlockAction extends CustomAction<User> {
  override getText(item: User): string {
    switch (item.status) {
      case UserStatus.INACTIVE:
        return 'user.unlock';
      default:
        return 'user.lock';
    }
  }

  override isEnabled(user: User): Observable<boolean> {
    return of(!user.isSecondaryOrgMember);
  }
}
